import { useSvgParsedStyle } from '@/_shared/hooks/useSvgParsedStyle';
import { SvgProps } from '@/_shared/types/svg';

export const TriangleAlert = ({ style }: SvgProps) => {
  const { primaryColorToUse, heightToUse, widthToUse } = useSvgParsedStyle({
    defaultWidth: '25',
    defaultHeight: '25',
    strokeAsPrimary: true,
    style,
  });

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={widthToUse}
      height={heightToUse}
      fill='none'
      viewBox='0 0 25 25'
    >
      <path
        d='M12.022 8.99998V13M12.022 17H12.032M21.752 18L13.752 3.99998C13.5776 3.69218 13.3246 3.43617 13.0189 3.25805C12.7133 3.07993 12.3658 2.98608 12.012 2.98608C11.6582 2.98608 11.3108 3.07993 11.0051 3.25805C10.6994 3.43617 10.4465 3.69218 10.272 3.99998L2.27202 18C2.09571 18.3053 2.00325 18.6519 2.00403 19.0045C2.00481 19.3571 2.0988 19.7032 2.27647 20.0078C2.45414 20.3124 2.70917 20.5646 3.01572 20.7388C3.32227 20.9131 3.66943 21.0032 4.02202 21H20.022C20.3729 20.9996 20.7176 20.9069 21.0213 20.7313C21.3251 20.5556 21.5772 20.3031 21.7525 19.9991C21.9278 19.6951 22.0201 19.3504 22.02 18.9995C22.0199 18.6486 21.9275 18.3039 21.752 18Z'
        stroke={primaryColorToUse}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};
